export default __webpack_public_path__ + "static/media/gallery - potions_07.8c5ebb5b.jpg";